import Documents from "../singleton/documents";
import DocumentValue from "../singleton/document-value";

export default {

    getValueByPathSync: DocumentValue.getByPathSync.bind(DocumentValue),

    create: Documents.create.bind(Documents),

    replace: Documents.replace.bind(Documents), // TODO - Check if it needed

    prepare: Documents.prepare.bind(Documents),

    delete: Documents.delete.bind(Documents)

}